"use client";

import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PackageIcon, PackageOpenIcon } from "lucide-react";
import { toggleBuilt } from "../_server/toggleBuilt";

interface Props {
	deckId: string;
	built: boolean;
}

export const ToggleBuiltButton: React.FC<Props> = ({ deckId, built }) => {
	const queryClient = useQueryClient();
	const { mutate, isPending } = useMutation({
		mutationFn: async () => {
			await toggleBuilt(deckId);
		},
		onSettled: async () => {
			queryClient.invalidateQueries({
				queryKey: ["decks", "personal"],
			});
			queryClient.invalidateQueries({
				queryKey: ["deck", deckId],
			});
		},
	});

	return (
		<DropdownMenuItem
			onClick={(e) => {
				e.stopPropagation();
				mutate();
			}}
		>
			{built ? (
				<PackageOpenIcon className="mr-2 h-4 w-4" />
			) : (
				<PackageIcon className="mr-2 h-4 w-4" />
			)}
			{built ? "Set unbuilt" : "Set built"}
		</DropdownMenuItem>
	);
};
